import axios from '@/plugins/axios'

export default {
  namespaced: true,

  state: {
    loading: false,
    newsletters: [],
    page: 1,
    page_size: 10,
    order_column: 'created_at',
    order_type: 'desc'
  },

  mutations: {
    setNewsletters(state, payload) {
      state.newsletters = payload
    },
    setPage(state, payload) {
      state.page = payload
    },
    setPageSize(state, payload) {
      state.page_size = payload
    },
    setOrdering(state, payload) {
      state.order_column = payload.column
      state.order_type = payload.type
    },
    setLoading(state, payload) {
      state.loading = payload
    }
  },

  actions: {
    read({ commit }) {
      commit('setLoading', true)
      axios.content
        .get('example')
        .then(r => {
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    }
  },

  getters: {}
}
